// I2: the source PNGs (1254x1254, 1.2-2 Mo each) are kept on disk as originals, but the
// app serves WebP variants generated from them — 400px for catalogue cards, 900px for the
// recipe-page hero. Both variants live next to the PNG under the same slug.
const stripExtension = (path: string): string => path.replace(/\.[^./]+$/, '')

export const cardImageSrc = (image: string): string => `${stripExtension(image)}-400.webp`

export const cardImageSrcSet = (image: string): string => {
  const base = stripExtension(image)
  return `${base}-400.webp 400w, ${base}-900.webp 900w`
}

export const heroImageSrc = (image: string): string => `${stripExtension(image)}-900.webp`
